import { localize } from "@/i18n/translate";
import { motion } from "framer-motion";
export const EASE = [0.22, 1, 0.36, 1];
export const Reveal = ({
  children,
  delay = 0,
  y = 28,
  className = "",
  ...rest
}) => <motion.div className={className} initial={{
  opacity: 0,
  y
}} whileInView={{
  opacity: 1,
  y: 0
}} viewport={{
  once: true,
  amount: 0.15
}} transition={{
  duration: 0.9,
  ease: EASE,
  delay
}} {...rest}>
    {localize(children)}
  </motion.div>;
export const SectionHead = ({
  index,
  label,
  title,
  intro,
  dark = false
}) => <div className="grid grid-cols-12 gap-x-6 gap-y-6">
    <Reveal className="col-span-12 lg:col-span-3">
      <p className={`eyebrow ${dark ? "!text-zinc-400" : ""}`}>
        <span className="text-signal">{localize(index)}</span> — {localize(label)}
      </p>
    </Reveal>
    <div className="col-span-12 lg:col-span-9">
      <Reveal delay={0.05}>
        <h2 className="font-display text-[2rem] font-bold leading-[1.02] tracking-[-0.03em] [hyphens:auto] [overflow-wrap:anywhere] sm:text-5xl sm:[overflow-wrap:normal] lg:text-6xl">
          {localize(title)}
        </h2>
      </Reveal>
      {localize(intro && <Reveal delay={0.12}>
          <p className={`mt-6 max-w-2xl text-base leading-relaxed md:text-lg ${dark ? "text-zinc-300" : "text-mute"}`}>
            {localize(intro)}
          </p>
        </Reveal>)}
    </div>
  </div>;
